export enum CommunicationDirection {
    Inbound = 1,
    Outbound = 2
}
